import React from "react";
import { Grid } from "@material-ui/core";
import { Text, SVG, SelectBox } from "sunrise-ui";
import EnlargeImage from "../Users/EnlargeImage";
import "./MachineCard.scss";

const displayDate = (dateString: string) => {
  if (dateString) {
    const date = new Date(dateString);
    const month = date.toLocaleString("default", { month: "short" });
    const day = `0${date.getDate()}`.slice(-2);
    return `${day} ${month}, ${date.getFullYear()}`;
  }
  return "";
};

const displayDateAndTime = (dateString: string) => {
  if (dateString) {
    const date = new Date(dateString);
    const month = date.toLocaleString("default", { month: "short" });
    const day = `0${date.getDate()}`.slice(-2);
    let hours = date.getHours();
    const MM = `0${date.getMinutes()}`.slice(-2);
    const AMPM = hours >= 12 ? "pm" : "am";
    hours = hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const HH = `0${hours}`.slice(-2);
    return `${day} ${month}, ${date.getFullYear()}, ${HH}:${MM} ${AMPM}`;
  }
  return "";
};

const MachineLogDrawer = (props: any) => {
  const { drawerData, toggleDrawer, machineData, dieselData } = props;

  // ---------------for enlarge image modal-------------
  const [modalData, setModalData] = React.useState({
    image: "",
    isOpen: false,
  });
  const [workShift, setWorkShift] = React.useState("Day");

  const handleOpen = (photo: string) => {
    setModalData({ ...modalData, image: photo, isOpen: true });
  };

  return (
    <Grid>
      <div className="right_drawer_page">
        <Grid container className="drwaer_container p1">
          <Grid item xs={11}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb1 mt0 capitalize"
            >
              {`${displayDate(drawerData?.date)} Details`}
            </Text>
          </Grid>
          <Grid
            item
            xs={1}
            className="pointer"
            onClick={() => toggleDrawer(false)}
          >
            <SVG type={"close"} />
          </Grid>
          {/* -----------------------Operator detail---------- ------------*/}
          <Grid item xs={12}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb1 mt0"
            >
              Operator Details
            </Text>
          </Grid>
          <Grid
            item
            xs={12}
            container
            spacing={1}
            className="right_drawer_details_container"
          >
            {/* ---------day operator name--------- */}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="mb mt0"
              >
                <span className="fw400">Morning Shift Operator</span>
                <span className="float-right">
                  {drawerData?.dayShift?.operator?.name}
                </span>
              </Text>
            </Grid>
            {/* ---------night operator name--------- */}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="mb mt0"
              >
                <span className="fw400">Night Shift Operator</span>
                <span className="float-right">
                  {drawerData?.nightShift?.operator?.name}
                </span>
              </Text>
            </Grid>
            {/* ----------Site Location----------- */}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="mb mt0"
              >
                <span className="fw400">Site Location</span>
                <span className="float-right">{drawerData?.siteLocation}</span>
              </Text>
            </Grid>
          </Grid>
          {/* -----------------------Diesel detail---------- ------------*/}
          <Grid item xs={12}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb1 mt1"
            >
              Diesel Details
            </Text>
          </Grid>
          <Grid
            item
            xs={12}
            container
            spacing={1}
            className="right_drawer_details_container"
          >
            {/* ---------diesel filled by--------- */}
            <Grid item xs={12} container>
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb mt0"
                >
                  <span className="fw400">Diesel Filled by</span>
                </Text>
              </Grid>
              <Grid item xs={8}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb mt0"
                >
                  <span className="float-right">
                    {dieselData?.dieselFilledBy?.name}
                  </span>
                </Text>
              </Grid>
            </Grid>
            {/* ---------diesel filling date time--------- */}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="mb mt0"
              >
                <span className="fw400">Diesel Filling Date and Time</span>
                <span className="float-right">
                  {displayDateAndTime(dieselData?.filledAt)}
                </span>
              </Text>
            </Grid>
            {/* ----------Diesel Issued----------- */}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="mb mt0"
              >
                <span className="fw400">Diesel Issued</span>
                <span className="float-right">{dieselData?.dieselIssued}</span>
              </Text>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={14}
              className="mb0 mt1"
            >
              <span className="fw400">Select Shift</span>
            </Text>
            <SelectBox
              data={["Day", "Night"]}
              placeHolder="Select Shift"
              value={workShift}
              defaultVal={workShift}
              onChange={(e: any) => {
                setWorkShift(e.target.value);
              }}
              borderColor={"primary"}
            />
          </Grid>

          <Grid
            item
            xs={12}
            container
            spacing={1}
            className="right_drawer_details_container"
          >
            {/* ---------Start reading--------- */}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="mb mt1"
              >
                <span className="fw400">Starting Reading (Hmr)</span>
                <span className="float-right">
                  {workShift === "Day" && drawerData?.dayShift?.startReading}
                  {workShift === "Night" &&
                    drawerData?.nightShift?.startReading}
                </span>
              </Text>
            </Grid>
            {/* ---------Close Reading--------- */}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="mb mt0"
              >
                <span className="fw400">Closing Reading (Hmr)</span>
                <span className="float-right">
                  {workShift === "Day" && drawerData?.dayShift?.closeReading}
                  {workShift === "Night" &&
                    drawerData?.nightShift?.closeReading}
                </span>
              </Text>
            </Grid>
            {/* ---------Avg Diesel Consumption--------- */}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="mb mt0"
              >
                <span className="fw400">Average Diesel consumption</span>
                <span className="float-right">
                  {machineData?.avgDieselConsumption}
                </span>
              </Text>
            </Grid>
            {/* ---------Avg running hours per day--------- */}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="mb mt0"
              >
                <span className="fw400">Average Running Hrs Per Day</span>
                <span className="float-right">
                  {Math.floor(
                    (machineData?.avgRunningHoursPerDay * 100) / (60 * 60)
                  ) / 100}
                </span>
              </Text>
            </Grid>

            <Grid item xs={12} container>
              <Grid item xs={5} className="right_drawer_align_items">
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb1 mt0"
                >
                  <span className="fw400">Starting Reading Snapshot</span>
                </Text>
                <img
                  src={
                    workShift === "Day"
                      ? drawerData?.dayShift?.startingSnapshot
                      : drawerData?.nightShift?.startingSnapshot
                  }
                  alt="..."
                  className="drawer-photo pointer"
                  onClick={() => {
                    handleOpen(
                      workShift === "Day"
                        ? drawerData?.dayShift?.startingSnapshot
                        : drawerData?.nightShift?.startingSnapshot
                    );
                  }}
                />
              </Grid>
              <Grid item xs={5}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb1 mt0"
                >
                  <span className="fw400">Closing Reading Snapshot</span>
                </Text>
                <img
                  src={
                    workShift === "Day"
                      ? drawerData?.dayShift?.closingSnapshot
                      : drawerData?.nightShift?.closingSnapshot
                  }
                  alt="..."
                  className="drawer-photo pointer"
                  onClick={() => {
                    handleOpen(
                      workShift === "Day"
                        ? drawerData?.dayShift?.closingSnapshot
                        : drawerData?.nightShift?.closingSnapshot
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* -----------------------Machine details---------- ------------*/}
          <Grid item xs={12}>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb1 mt1"
            >
              Machine Details
            </Text>
          </Grid>

          <Grid
            item
            xs={12}
            container
            spacing={1}
            className="right_drawer_details_container"
          >
            {/* ----------Project Assigned Date----------- */}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="mb mt0"
              >
                <span className="fw400">Project Assigned Date and Time</span>
                <span className="float-right">
                  {displayDateAndTime(machineData?.assignedToProjectOn)}
                </span>
              </Text>
            </Grid>
            {/* ----------Total Working hours----------- */}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="mb mt0"
              >
                <span className="fw400">
                  Total Working Hours in this Project
                </span>
                <span className="float-right">
                  {machineData?.totalWorkingHours}
                </span>
              </Text>
            </Grid>
          </Grid>
        </Grid>
      </div>
      {/* ---------------Enlarge Image Modal---------- */}
      <EnlargeImage modalData={modalData} />
    </Grid>
  );
};

export default MachineLogDrawer;
